<template>
  <div>
    <!-- 기본현황 -->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 기본현황</h5>
      <div class="writeGridContainer">
        <div>
          <div>시설물번호</div>
          <p v-if="isPrint">{{form.facilityNumber}}</p>
          <ml-input v-else v-model="form.facilityNumber" :readonly="readonly"/>
        </div>
        <div>
          <div>관리번호</div>
          <p v-if="isPrint" class="py-2">{{form.managementNumber}}</p>
          <ml-input v-else v-model="form.managementNumber" :readonly="readonly"/>
        </div>
        <div>
          <div>시설물명</div>
          <p v-if="isPrint" class="py-2">{{form.facilityName}}</p>
          <ml-input v-else v-model="form.facilityName" :readonly="readonly"/>
        </div>
        <div>
          <div>하천명 - 구분</div>
          <p v-if="isPrint" class="py-2">{{form.routeDivision}}</p>
          <ml-input v-else v-model="form.routeDivision" :readonly="readonly"/>
        </div>
        <div>
          <div>하천명 - 세부노선</div>
          <p v-if="isPrint" class="py-2">{{form.routeDetail}}</p>
          <ml-input v-else v-model="form.routeDetail" :readonly="readonly"/>
        </div>
        <div class="writeGridLineItem">
          <div>시설물 구분</div>
          <p v-if="isPrint" class="py-2">{{form.cat1}}</p>
          <ml-input v-else-if="readonly" readonly v-model="form.cat1" />
          <vs-select v-else autocomplete v-model="form.cat1" @change="onChangeCat1">
            <vs-select-item v-for="(option, idx) in cat1List" :key="idx" :text="option" :value="option" />
          </vs-select>
        </div>
        <div class="writeGridLineItem">
          <div>시설물 종류</div>
          <p v-if="isPrint" class="py-2">{{form.cat2}}</p>
          <ml-input v-else-if="readonly" readonly v-model="form.cat2" />
          <vs-select v-else :disabled="!form.cat1" autocomplete v-model="form.cat2" @change="onChangeCat2">
            <vs-select-item v-for="(option, idx) in cat2List" :key="idx" :text="option" :value="option" />
          </vs-select>
        </div>
        <div class="writeGridLineItem">
          <div>시설물 세분류</div>
          <p v-if="isPrint" class="py-2">{{form.cat3}}</p>
          <ml-input v-else-if="readonly" readonly v-model="form.cat3" />
          <vs-select v-else :disabled="!form.cat2" autocomplete v-model="form.cat3" @change="onChangeCat3">
            <vs-select-item v-for="(option, idx) in cat3List" :key="idx" :text="option" :value="option" />
          </vs-select>
        </div>
        <div>
          <div>종별</div>
          <p v-if="isPrint" class="py-2">{{form.classification}}</p>
          <ml-input v-else-if="readonly" readonly v-model="form.classification" />
          <vs-select v-else :disabled="!form.cat3" autocomplete v-model="form.classification" @change="onChangeCat4">
            <vs-select-item v-for="(option, idx) in classificationList" :key="idx" :text="option" :value="option" />
          </vs-select>
        </div>
        <div>
          <div>SOC성능평가대상</div>
          <div class="radio">
            <vs-radio v-for="option in ['유', '무']" :key="`SOC성능평가대상_${option}`" v-model="form.socEvaluationTarget"
                      vs-name="SOC성능평가대상" :vs-value="option" :disabled="readonly || isPrint">{{ option }}
            </vs-radio>
          </div>
        </div>
        <div class="writeGridCol2">
          <div>주소</div>
          <p v-if="isPrint" class="py-2">{{form.address}}</p>
          <ml-input v-else v-model="form.address" placeholder="(시,도) (시,군,구) (읍,면,동) (리, 번지 등 주소)" :readonly="readonly" />
        </div>
      </div>
      <div class="writeGridContainer">
        <div>
          <div>관리주체</div>
          <p v-if="isPrint" class="py-2">{{form.management_entity}}</p>
          <ml-input v-else v-model="form.management_entity" :readonly="readonly" />
        </div>
        <div>
          <div>관리주체구분</div>
          <div class="radio">
            <vs-radio v-for="option in ['중앙부처', '지자체', '(국가/지방)공기업', '민간']" :key="`관리주체구분_${option}`"
                      v-model="form.management_type" vs-name="관리주체구분" :vs-value="option" :disabled="readonly || isPrint">{{ option }}
            </vs-radio>
          </div>
        </div>
      </div>
      <div class="writeGridContainer">
        <div>
          <div>소유자</div>
          <p v-if="isPrint" class="py-2">{{form.owner}}</p>
          <ml-input v-else v-model="form.owner" :readonly="readonly" />
        </div>
        <div>
          <div>소유자구분</div>
          <div class="radio">
            <vs-radio v-for="option in ['중앙부처', '지자체', '(국가/지방)공기업', '민간']" :key="`소유자구분_${option}`"
                      v-model="form.ownerType" vs-name="소유자구분" :vs-value="option" :disabled="readonly || isPrint">{{ option }}
            </vs-radio>
          </div>
        </div>
      </div>
      <div class="writeGridContainer">
        <div>
          <div>사업계획승인일</div>
          <p v-if="isPrint" class="py-2">{{form.businessPlanApprovalDate}}</p>
          <DateSelector v-else v-model="form.businessPlanApprovalDate" :readonly="readonly" />
        </div>
        <div>
          <div>준공(사용승인)일</div>
          <p v-if="isPrint" class="py-2">{{form.completionDate}}</p>
          <DateSelector v-else v-model="form.completionDate" :readonly="readonly" />
        </div>
        <div>
          <div>하자담보책임만료일</div>
          <p v-if="isPrint" class="py-2">{{form.defectLiabilityExpirationDate1}}</p>
          <DateSelector v-else v-model="form.defectLiabilityExpirationDate1" :readonly="readonly" />
        </div>
        <div>
          <div>상세제원</div>
          <div class="radio">
            <vs-radio v-for="option in ['유', '무']" :key="`상세제원_${option}`" v-model="form.detailedSpecifications"
                      vs-name="상세제원" :vs-value="option" :disabled="readonly || isPrint">{{ option }}
            </vs-radio>
          </div>
        </div>
        <div>
          <div>안전점검 및 정밀안전진단 이력</div>
          <div class="radio">
            <vs-radio v-for="option in ['유', '무']" :key="`안전점검및정밀안전진이력_${option}`"
                      v-model="form.safetyInspectionAndDiagnosisHistory" vs-name="안전점검및정밀안전진이력" :vs-value="option" :disabled="readonly || isPrint">
              {{ option }}
            </vs-radio>
          </div>
        </div>
        <div>
          <div>보수·보강 이력</div>
          <div class="radio">
            <vs-radio v-for="option in ['유', '무']" :key="`보수보강이력_${option}`"
                      v-model="form.repairAndReinforcementHistory" vs-name="보수보강이력" :vs-value="option" :disabled="readonly || isPrint">{{ option }}
            </vs-radio>
          </div>
        </div>
      </div>
      <div class="writeGridContainer">
        <div>
          <div>환기구 덮개 (접근 가능한 환기구)</div>
          <div class="radio">
            <vs-radio v-for="option in ['유', '무']" :key="`환기구덮개_${option}`" v-model="form.accessibleVentCover"
                      vs-name="환기구 덮개 (접근 가능한 환기구)" :vs-value="option" :disabled="readonly || isPrint">{{ option }}
            </vs-radio>
          </div>
        </div>
      </div>
      <div class="writeGridContainer">
        <div>
          <div>설계기간</div>
          <p v-if="isPrint" class="py-2">{{form.designPeriod ? `${form.designPeriod.sDate} ~ ${form.designPeriod.eDate}` : ''}}</p>
          <DateSelectorRang v-else v-model="form.designPeriod" :readonly="readonly" />
        </div>
        <div>
          <div>설계자</div>

          <p v-if="isPrint" class="py-2">{{form.designer}}</p>
          <ml-input v-else v-model="form.designer" :readonly="readonly" />
        </div>
        <div>
          <!--            <div>하자담보책임만료일</div>-->
          <!--            <DateSelector v-model="form.defectLiabilityExpirationDate2" />-->
        </div>
        <div>
          <div>공사기간</div>
          <p v-if="isPrint" class="py-2">{{form.constructionPeriod ? `${form.constructionPeriod.sDate} ~ ${form.constructionPeriod.eDate}` : ''}}</p>
          <DateSelectorRang v-else v-model="form.constructionPeriod" :readonly="readonly" />
        </div>
        <div>
          <div>시공자</div>
          <p v-if="isPrint" class="py-2">{{form.contractor}}</p>
          <ml-input v-else v-model="form.contractor" :readonly="readonly" />
        </div>
        <div>
          <div>총공사비</div>
          <div class="after-text">
            <p v-if="isPrint" class="py-2">{{form.totalConstructionCost}}</p>
            <comma-input v-else v-model="form.totalConstructionCost" :readonly="readonly" />
            <span>백만원</span>
          </div>
        </div>
        <div>
          <div>내진설계 대상 유무</div>
          <div class="radio">
            <vs-radio v-for="option in ['대상', '미대상', '불명']" :key="`내진설계대상유무_${option}`"
                      v-model="form.seismicDesignTarget" vs-name="내진설계대상유무" :vs-value="option" :disabled="readonly || isPrint">{{ option }}
            </vs-radio>
          </div>
        </div>
        <div>
          <div>내진설계 적용 유무</div>
          <div class="radio">
            <vs-radio v-for="option in ['적용', '미적용', '불명']" :key="`내진설계적용유무_${option}`"
                      v-model="form.seismicDesignApplication" vs-name="내진설계적용유무" :vs-value="option" :disabled="readonly || isPrint">{{ option }}
            </vs-radio>
          </div>
        </div>
        <div>
          <div>적용내진설계기준</div>
          <p v-if="isPrint" class="py-2">{{form.seismicDesignStandard}}</p>
          <ml-input v-else v-model="form.seismicDesignStandard" :readonly="readonly" />
        </div>
        <div>
          <div>내진성능평가 실시 유무</div>
          <div class="radio">
            <vs-radio v-for="option in ['실시', '미실시', '불명']" :key="`내진성능평가실시유무_${option}`"
                      v-model="form.seismicPerformanceEvaluation" vs-name="내진성능평가실시유무" :vs-value="option" :disabled="readonly || isPrint">{{ option }}
            </vs-radio>
          </div>
        </div>
        <div>
          <div>내진보강 유무</div>
          <div class="radio">
            <vs-radio v-for="option in ['실시', '미실시', '불명']" :key="`내진보강유무_${option}`"
                      v-model="form.seismicReinforcement" vs-name="내진보강유무" :vs-value="option" :disabled="readonly || isPrint">{{ option }}
            </vs-radio>
          </div>
        </div>
      </div>
      <div class="writeGridContainer">
        <div>
          <div>영21조대상</div>
          <div class="radio">
            <vs-radio v-for="option in ['예', '아니오']" :key="`영21조대상_${option}`" v-model="form.young21Target"
                      vs-name="영21조대상" :vs-value="option" :disabled="readonly || isPrint">{{ option }}
            </vs-radio>
          </div>
        </div>
        <div>
          <div>감리기간</div>
          <p v-if="isPrint" class="py-2">{{form.auditPeriod ? `${form.auditPeriod.sDate} ~ ${form.auditPeriod.eDate}` : ''}}</p>
          <DateSelectorRang v-else v-model="form.auditPeriod" :readonly="readonly" />
        </div>
        <div>
          <div>감리자(책임감리원)</div>
          <p v-if="isPrint" class="py-2">{{form.auditor}}</p>
          <ml-input v-else v-model="form.auditor" :readonly="readonly" />
        </div>
        <div>
          <div>사업주체(발주자)</div>
          <p v-if="isPrint" class="py-2">{{form.projectOwner}}</p>
          <ml-input v-else v-model="form.projectOwner" :readonly="readonly" />
        </div>
        <div>
          <div>공사명</div>
          <p v-if="isPrint" class="py-2">{{form.constructionName}}</p>
          <ml-input v-else v-model="form.constructionName" :readonly="readonly" />
        </div>
        <div>
          <div>공사감독·공사관리관</div>
          <p v-if="isPrint" class="py-2">{{form.constructionSupervisor}}</p>
          <ml-input v-else v-model="form.constructionSupervisor" :readonly="readonly" />
        </div>
        <div>
          <div>작성일</div>
          <p v-if="isPrint" class="py-2">{{form.creationDate}}</p>
          <DateSelector v-else v-model="form.creationDate" :readonly="readonly" />
        </div>
        <div>
          <div>작성자</div>
          <p v-if="isPrint" class="py-2">{{form.author}}</p>
          <ml-input v-else v-model="form.author" :readonly="readonly" />
        </div>
        <div>
          <div>서명</div>
          <sign-field v-model="form.signature" :readonly="readonly || isPrint" />
        </div>
        <div>
          <div>최종 수정일</div>
          <p v-if="isPrint" class="py-2">{{form.lastModifiedDate}}</p>
          <DateSelector v-else v-model="form.lastModifiedDate" :readonly="readonly" />
        </div>
        <div>
          <div>최종 수정자</div>
          <p v-if="isPrint" class="py-2">{{form.lastModifiedBy}}</p>
          <ml-input v-else v-model="form.lastModifiedBy" :readonly="readonly" />
        </div>
        <div class="writeGridLineItem">
          <div>비고</div>
          <p v-if="isPrint" class="py-2" style="white-space:pre-wrap;">{{form.remarks}}</p>
          <ml-textarea v-else v-model="form.remarks" :readonly="readonly" />
        </div>
      </div>
    </div>

    <!-- 상세제원 -->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 상세제원</h5>

      <table>
        <tr>
          <th rowspan="2">처리구역</th>
          <th colspan="3">처리용량</th>
        </tr>
        <tr>
          <th>일평균</th>
          <th>일최대</th>
          <th>시간최대</th>
        </tr>
        <tr>
          <td>
            <p v-if="isPrint" class="p-2 text-left" style="font-weight: 400;">{{form.처리구역}}</p>
            <ml-input v-else class="w-full" v-model="form.처리구역" :readonly="readonly" />
          </td>
          <td>
            <p v-if="isPrint" class="p-2 text-left" style="font-weight: 400;">{{form.일평균}}</p>
            <ml-input v-else class="w-full" v-model="form.일평균" :readonly="readonly" />
          </td>
          <td>
            <p v-if="isPrint" class="p-2 text-left" style="font-weight: 400;">{{form.일최대}}</p>
            <ml-input v-else class="w-full" v-model="form.일최대" :readonly="readonly" />
          </td>
          <td>
            <p v-if="isPrint" class="p-2 text-left" style="font-weight: 400;">{{form.시간최대}}</p>
            <ml-input v-else class="w-full" v-model="form.시간최대" :readonly="readonly" />
          </td>
        </tr>
      </table>

      <table class="mt-2">
        <colgroup>
          <col width="140px"/>
        </colgroup>
        <tr>
          <th rowspan="2">처리방식</th>
          <th>1차 처리</th>
          <th>2차(고도)처리</th>
          <th>3차(슬러지)처리</th>
        </tr>
        <tr>
          <td>
            <p v-if="isPrint" class="p-2 text-left" style="font-weight: 400;">{{form.처리방식1차}}</p>
            <ml-input v-else class="w-full" v-model="form.처리방식1차" :readonly="readonly" />
          </td>
          <td>
            <p v-if="isPrint" class="p-2 text-left" style="font-weight: 400;">{{form.처리방식2차}}</p>
            <ml-input v-else class="w-full" v-model="form.처리방식2차" :readonly="readonly" />
          </td>
          <td>
            <p v-if="isPrint" class="p-2 text-left" style="font-weight: 400;">{{form.처리방식3차}}</p>
            <ml-input v-else class="w-full" v-model="form.처리방식3차" :readonly="readonly" />
          </td>
        </tr>
      </table>

      <table class="mt-2">
        <colgroup>
          <col width="140px"/>
        </colgroup>
        <tr>
          <th colspan="5">유입수질</th>
          <th colspan="5">방류수질</th>
          <th rowspan="3">처리방식</th>
        </tr>
        <tr>
          <td>BOD</td>
          <td>COD</td>
          <td>SS</td>
          <td>T-N</td>
          <td>T-P</td>
          <td>BOD</td>
          <td>COD</td>
          <td>SS</td>
          <td>T-N</td>
          <td>T-P</td>
        </tr>
        <tr>
          <td>
            <p v-if="isPrint" class="p-2 text-left" style="font-weight: 400;">{{form.유입수질_BOD}}</p>
            <ml-input v-else class="w-full" v-model="form.유입수질_BOD" />
          </td>
          <td>
            <p v-if="isPrint" class="p-2 text-left" style="font-weight: 400;">{{form.유입수질_COD}}</p>
            <ml-input v-else class="w-full" v-model="form.유입수질_COD" />
          </td>
          <td>
            <p v-if="isPrint" class="p-2 text-left" style="font-weight: 400;">{{form.유입수질_SS}}</p>
            <ml-input v-else class="w-full" v-model="form.유입수질_SS" />
          </td>
          <td>
            <p v-if="isPrint" class="p-2 text-left" style="font-weight: 400;">{{form.유입수질_TN}}</p>
            <ml-input v-else class="w-full" v-model="form.유입수질_TN" />
          </td>
          <td>
            <p v-if="isPrint" class="p-2 text-left" style="font-weight: 400;">{{form.유입수질_TP}}</p>
            <ml-input v-else class="w-full" v-model="form.유입수질_TP" />
          </td>
          <td>
            <p v-if="isPrint" class="p-2 text-left" style="font-weight: 400;">{{form.방류수질_BOD}}</p>
            <ml-input v-else class="w-full" v-model="form.방류수질_BOD" />
          </td>
          <td>
            <p v-if="isPrint" class="p-2 text-left" style="font-weight: 400;">{{form.방류수질_COD}}</p>
            <ml-input v-else class="w-full" v-model="form.방류수질_COD" />
          </td>
          <td>
            <p v-if="isPrint" class="p-2 text-left" style="font-weight: 400;">{{form.방류수질_SS}}</p>
            <ml-input v-else class="w-full" v-model="form.방류수질_SS" />
          </td>
          <td>
            <p v-if="isPrint" class="p-2 text-left" style="font-weight: 400;">{{form.방류수질_TN}}</p>
            <ml-input v-else class="w-full" v-model="form.방류수질_TN" />
          </td>
          <td>
            <p v-if="isPrint" class="p-2 text-left" style="font-weight: 400;">{{form.방류수질_TP}}</p>
            <ml-input v-else class="w-full" v-model="form.방류수질_TP" />
          </td>
        </tr>
      </table>

      <table class="mt-2">
        <colgroup>
          <col width="140px"/>
        </colgroup>
        <tr>
          <th rowspan="2">하수 관거시설</th>
          <th>관종</th>
          <th>관경(mm)</th>
          <th>연장(km)</th>
          <th>기타시설</th>
        </tr>
        <tr>
          <td>
            <p v-if="isPrint" class="p-2 text-left" style="font-weight: 400;">{{form.하수관거시설_관종}}</p>
            <ml-input v-else class="w-full" v-model="form.하수관거시설_관종"/>
          </td>
          <td>
            <p v-if="isPrint" class="p-2 text-left" style="font-weight: 400;">{{form.하수관거시설_관경}}</p>
            <ml-input v-else class="w-full" v-model="form.하수관거시설_관경"/>
          </td>
          <td>
            <p v-if="isPrint" class="p-2 text-left" style="font-weight: 400;">{{form.하수관거시설_연장}}</p>
            <ml-input v-else class="w-full" v-model="form.하수관거시설_연장"/>
          </td>
          <td>
            <p v-if="isPrint" class="p-2 text-left" style="font-weight: 400;">{{form.하수관거시설_기타시설}}</p>
            <ml-input v-else class="w-full" v-model="form.하수관거시설_기타시설"/>
          </td>
        </tr>
      </table>

      <table class="mt-2">
        <colgroup>
          <col width="140px"/>
        </colgroup>
        <tr>
          <th rowspan="2">수처리 시설</th>
          <th>침사지</th>
          <th>유입펌프량</th>
          <th>최초침전지</th>
          <th>포기조</th>
          <th>최종침전지</th>
          <th>고도처리시설</th>
          <th>기타시설</th>
        </tr>
        <tr>
          <td>
            <p v-if="isPrint" class="p-2 text-left" style="font-weight: 400;">{{form.수처리시설_침사지}}</p>
            <ml-input v-else class="w-full" v-model="form.수처리시설_침사지"/>
          </td>
          <td>
            <p v-if="isPrint" class="p-2 text-left" style="font-weight: 400;">{{form.수처리시설_유입펌프량}}</p>
            <ml-input v-else class="w-full" v-model="form.수처리시설_유입펌프량"/>
          </td>
          <td>
            <p v-if="isPrint" class="p-2 text-left" style="font-weight: 400;">{{form.수처리시설_최초침전지}}</p>
            <ml-input v-else class="w-full" v-model="form.수처리시설_최초침전지"/>
          </td>
          <td>
            <p v-if="isPrint" class="p-2 text-left" style="font-weight: 400;">{{form.수처리시설_포기조}}</p>
            <ml-input v-else class="w-full" v-model="form.수처리시설_포기조"/>
          </td>
          <td>
            <p v-if="isPrint" class="p-2 text-left" style="font-weight: 400;">{{form.수처리시설_최종침전지}}</p>
            <ml-input v-else class="w-full" v-model="form.수처리시설_최종침전지"/>
          </td>
          <td>
            <p v-if="isPrint" class="p-2 text-left" style="font-weight: 400;">{{form.수처리시설_고도처리시설}}</p>
            <ml-input v-else class="w-full" v-model="form.수처리시설_고도처리시설"/>
          </td>
          <td>
            <p v-if="isPrint" class="p-2 text-left" style="font-weight: 400;">{{form.수처리시설_기타시설}}</p>
            <ml-input v-else class="w-full" v-model="form.수처리시설_기타시설"/>
          </td>
        </tr>
      </table>

      <table class="mt-2">
        <colgroup>
          <col width="140px"/>
        </colgroup>
        <tr>
          <th rowspan="2">슬러지 처리시설</th>
          <th>농축조</th>
          <th>소화조</th>
          <th>탈수시설 - 탈수방법</th>
          <th>탈수시설 - 대수</th>
          <th>최종처분방법</th>
          <th>기타시설</th>
        </tr>
        <tr>
          <td v-if="isPrint" ><p class="p-2 text-left" style="font-weight: 400;">{{form.슬러지처리시설_농축조}}</p></td>
          <th v-else ><ml-input class="w-full" v-model="form.슬러지처리시설_농축조" /></th>

          <td v-if="isPrint" ><p class="p-2 text-left" style="font-weight: 400;">{{form.슬러지처리시설_소화조}}</p></td>
          <th v-else><ml-input class="w-full" v-model="form.슬러지처리시설_소화조" /></th>

          <td v-if="isPrint" ><p class="p-2 text-left" style="font-weight: 400;">{{form.슬러지처리시설_탈수시설_탈수방법}}</p></td>
          <th v-else><ml-input class="w-full" v-model="form.슬러지처리시설_탈수시설_탈수방법" /></th>

          <td v-if="isPrint" ><p class="p-2 text-left" style="font-weight: 400;">{{form.슬러지처리시설_탈수시설_대수}}</p></td>
          <th v-else><ml-input class="w-full" v-model="form.슬러지처리시설_탈수시설_대수" /></th>

          <td v-if="isPrint" ><p class="p-2 text-left" style="font-weight: 400;">{{form.슬러지처리시설_최종처분방법}}</p></td>
          <th v-else><ml-input class="w-full" v-model="form.슬러지처리시설_최종처분방법" /></th>

          <td v-if="isPrint" ><p class="p-2 text-left" style="font-weight: 400;">{{form.슬러지처리시설_기타시설}}</p></td>
          <th v-else><ml-input class="w-full" v-model="form.슬러지처리시설_기타시설" /></th>
        </tr>
      </table>

      <div class="writeGridContainer mt-2">
        <div class="writeGridLineItem">
          <div>기타 상세제원</div>
          <p v-if="isPrint" class="print-textarea">{{ form.기타상세제원 }}</p>
          <ml-textarea v-else v-model="form.기타상세제원" :readonly="readonly" />
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import SignField from "@/components/SignField.vue";
import DateSelectorRang from "@/components/selector/DateSelectorRang.vue";
import DateSelector from "@/components/selector/DateSelector.vue";

export default {
  name: "SewageTreatmentWriteBody",
  components: {
    SignField,
    DateSelectorRang,
    DateSelector,
  },
  props: {
    form: Object,
    categoryInfo: {
      type: Object,
      default: () => ({cat1: '', cat2: '', cat3: '', classification: ''}),
    },
    initCat1List: {
      type: Array,
      default: () => [],
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    isPrint: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    categoryInfo: {
      immediate: true,
      async handler(value) {
        this.form.facility_category_id = value.id;
        this.form.cat1 = value.cat1;
        await this.onChangeCat1(value.cat1);
        this.form.cat2 = value.cat2;
        await this.onChangeCat2(value.cat2);
        this.form.cat3 = value.cat3;
        await this.onChangeCat3(value.cat3);
        this.form.classification = value.classification;
      },
    },
  },
  data() {
    return {
      cat1List: [],
      cat2List: [],
      cat3List: [],
      classificationList: [],
    };
  },
  async mounted() {
    // 만약 this.initCat1List 가 비어있다면, this.initCat1List를 초기화한다.
    if (this.initCat1List.length === 0) {
      let facilityCategoryListData = this.$store.state.project.fieldFacilityCategoryList;
      if (!facilityCategoryListData.data || facilityCategoryListData.data.length === 0) {
        facilityCategoryListData = await this.$store.dispatch("project/LOAD_FIELD_FACILITY_CATEGORY_LIST", {});
      }
      const _cat1List = facilityCategoryListData.data.map((item) => item.cat1);
      const uniqueCat1List = [...new Set(_cat1List)];
      this.cat1List = this.sortItemAndMoveEtcItemToEnd(uniqueCat1List);
    } else {
      this.cat1List = this.initCat1List;
    }

    if (!this.cat1List.includes(this.form.cat1)) {
      this.form.cat1 = "";
      this.form.cat2 = "";
      this.form.cat3 = "";
      this.form.classification = "";
    } else {
      await this.onChangeCat1(this.form.cat1);
    }
  },
  methods: {
    // ==================================================
    // ==================== Category ====================
    // ==================================================
    async onChangeCat1(data) {
      if (data && !this.catLock) {
        this.categoryInfo.cat1 = data;

        let facilityCategoryListData = this.$store.state.project.fieldFacilityCategoryList;
        if (!facilityCategoryListData.data || facilityCategoryListData.data.length === 0) {
          facilityCategoryListData = await this.$store.dispatch("project/LOAD_FIELD_FACILITY_CATEGORY_LIST", {});
        }
        const _cat2List = facilityCategoryListData.data.filter((item) => item.cat1 === data).map((item) => item.cat2);
        const uniqueCat2List = [...new Set(_cat2List)];
        this.cat2List = this.sortItemAndMoveEtcItemToEnd(uniqueCat2List);

        // 만약 this.cat2가 this.cat2List 내에 없다면, cat2, cat3, cat4를 초기화한다.
        if (this.cat2List.indexOf(this.form.cat2) === -1) {
          this.form.cat2 = "";
          this.form.cat3 = "";
          this.form.classification = "";
        }
      }
    },
    async onChangeCat2(data) {
      if (data && !this.catLock) {
        this.categoryInfo.cat2 = data;

        let facilityCategoryListData = this.$store.state.project.fieldFacilityCategoryList;
        if (!facilityCategoryListData.data || facilityCategoryListData.data.length === 0) {
          facilityCategoryListData = await this.$store.dispatch("project/LOAD_FIELD_FACILITY_CATEGORY_LIST", {});
        }
        const _cat3List = facilityCategoryListData.data.filter((item) => item.cat1 === this.form.cat1 && item.cat2 === data).map((item) => item.cat3);
        const uniqueCat3List = [...new Set(_cat3List)];
        this.cat3List = this.sortItemAndMoveEtcItemToEnd(uniqueCat3List);

        // 만약 this.cat3가 this.cat3List 내에 없다면, cat3, cat4를 초기화한다.
        if (this.cat3List.indexOf(this.form.cat3) === -1) {
          this.form.cat3 = "";
          this.form.classification = "";
        }
      }
    },
    async onChangeCat3(data) {
      if (data && !this.catLock) {
        this.categoryInfo.cat3 = data;

        let facilityCategoryListData = this.$store.state.project.fieldFacilityCategoryList;
        if (!facilityCategoryListData.data || facilityCategoryListData.data.length === 0) {
          facilityCategoryListData = await this.$store.dispatch("project/LOAD_FIELD_FACILITY_CATEGORY_LIST", {});
        }
        const _classificationList = facilityCategoryListData.data.filter((item) => item.cat1 === this.form.cat1 && item.cat2 === this.form.cat2 && item.cat3 === data).map((item) => item.classification);
        const uniqueClassificationList = [...new Set(_classificationList)];
        this.classificationList = this.sortItemAndMoveEtcItemToEnd(uniqueClassificationList);

        // 만약 this.classification이 this.classificationList 내에 없다면, classification을 초기화한다.
        if (this.classificationList.indexOf(this.form.classification) === -1) {
          if (this.classificationList.length === 1) {
            this.form.classification = this.classificationList[0];
          } else {
            this.form.classification = "";
          }
        }
      }
    },
    onChangeCat4(classification) {
      if (!this.catLock) {
        this.form.classification = classification;
        this.categoryInfo.classification = classification;
        this.setFacilityCategoryId();
      }
    },

    /**
     * 현재까지 선택된 cat1, cat2, cat3, classification에 해당하는 facility_category_id를 설정하는 함수입니다.
     *
     * @returns {Promise<void>}
     */
    async setFacilityCategoryId() {
      let facilityCategoryListData = this.$store.state.project.fieldFacilityCategoryList;
      if (!facilityCategoryListData.data || facilityCategoryListData.data.length === 0) {
        facilityCategoryListData = await this.$store.dispatch("project/LOAD_FIELD_FACILITY_CATEGORY_LIST", {});
      }
      const found = facilityCategoryListData.data.filter((item) => item.cat1 === this.form.cat1 &&
        item.cat2 === this.form.cat2 &&
        item.cat3 === this.form.cat3 &&
        item.classification === this.classification);

      if (found.length > 0) {
        this.facility_category_id = found[0].id;
      }
    },

    /**
     * 배열을 정렬하고, "기타" 문자가 포함된 항목을 배열의 마지막으로 이동하는 함수입니다.
     * 이 함수는 배열을 받아서, 배열의 요소를 정렬한 후, "기타" 문자가 포함된 항목을 찾아 배열의 마지막으로 이동시킵니다.
     *
     * @param {Array} list - 정렬하고, "기타" 문자가 포함된 항목을 마지막으로 이동시킬 배열
     * @returns {Array} 정렬되고, "기타" 문자가 포함된 항목이 마지막으로 이동된 배열
     */
    sortItemAndMoveEtcItemToEnd(list) {
      list.sort();

      // list 아이템 중에 "기타" 문자가 포함된 항목을 찾아서 배열의 마지막으로 이동시킨다.
      const otherIdx = list.findIndex((item) => item.includes("기타"));
      if (otherIdx !== -1) {
        list.push(list.splice(otherIdx, 1)[0]);
      }

      return list;
    },

    // ==================================================
    // ==================================================
  },
}
</script>

<style scoped lang="scss">
table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  th,
  td {
    font-size: 14px;
    font-weight: 500;
    text-align: center;

    border: 1px solid #cdcdcd;
    padding: 5px;
  }

  th {
    background: #f9f9f9;
    padding: 10px 4px;
  }
}
.table-list {
  .action-button {
    margin-left: auto;
  }
}

.title {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
  position: relative;
  padding-left: 12px;

  &::before {
    content: "";
    width: 8px;
    height: 8px;
    background: #7e72f2;
    display: block;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: -8px;
    border-radius: 100%;
  }
}

.title-n {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
}

.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}

.size-search {
  width: 200px;
}

.input-se {
  width: 100%;

  &::v-deep .start-end-title {
    width: 114px;
    font-weight: 500;
    font-size: 14px;
    justify-content: flex-start;
  }

  &::v-deep .mr-2 {
    flex: 1;
    margin-right: 10px !important;
  }

  &::v-deep .mr-2 + .mr-2 {
    margin-right: 0 !important;

    &::before {
      content: "~";
      margin-right: 10px;
    }
  }

  &::v-deep .inline-block {
    width: 100% !important;
  }
}

.vs-table-primary .is-selected {
  background: rgba(126, 114, 242, 0.6) !important;
  color: white;
}

.search-item {
  width: 100% !important;
  margin: 0 !important;

  &::v-deep > div:first-child {
    width: 114px !important;
    font-weight: 500;
    font-size: 14px;
  }

  &::v-deep > div:last-child {
    flex: 1 !important;

    .con-select {
      width: 100%;
    }
  }
}

.upload-img {
  width: 100%;
  height: 318px !important;
  margin-top: 22px;
}
.none-card {
  box-shadow: none;
  border-radius: 0;
  display: inline-block;

  .vx-card__body {
    padding: 0 !important;
  }
}

span.up {
  color: #28c76f;
}

span.down {
  color: #ea5455;
}

.vs-table--tbody-table tr:nth-child(2n) {
  background-color: #f9f9f9;
}
</style>
